module.exports = "pegasus_template/assets/tech/realty/102.png";